import { Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import InfoIcon from '@swf/core/assets/icons/info.svg';

import AccountDate from '../../AccountDate/AccountDate';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../../TakeABreakFromUs.scss';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_12,
  TXTWCL_When_your_break_endsX_you_will_ELL,
  TXTWCL_XbXSorryX_we_canXt_process_you_ELL,
  TXTWCL_XbXYour_request_to_take_a_brea_ELL,
  TXTWCL_Your_account_has_been_restrict_ELL_2
} from './NationalExclusionResponseVegas.messages.json';

interface Props {
  error?: boolean;
  banEndDate?: string;
}

const NationalExclusionResponseVegas: React.FC<Props> = ({ error, banEndDate }) =>
  error ? (
    <StarsInfo type="error" className={styles.infoBox}>
      <span className={styles.infoBoxHeading}>
        <InfoIcon className={styles.infoError} />
        <Translation tagName="div" {...TXTWCL_XbXSorryX_we_canXt_process_you_ELL} />
      </span>
      <Translation {...TXTWCL_Your_account_has_been_restrict_ELL_2} />
    </StarsInfo>
  ) : (
    <StarsInfo type="confirmation" className={styles.infoBox}>
      <span className={styles.infoBoxHeading}>
        <InfoIcon className={styles.infoSuccess} />
        <Translation tagName="div" {...TXTWCL_XbXYour_request_to_take_a_brea_ELL} />
      </span>
      <Translation
        {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_12}
        values={{
          0: (
            <b>
              <AccountDate date={banEndDate ?? new Date()} />
            </b>
          )
        }}
      />{' '}
      <Translation {...TXTWCL_When_your_break_endsX_you_will_ELL} />
    </StarsInfo>
  );

export default NationalExclusionResponseVegas;
